<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" data-testid="client-banner-email" @click="open">
            <span v-if="client.email_address.length > 0" style="border-bottom: 1px dotted gray">
                <i class="fa fa-envelope-square" aria-hidden="true"></i>
                <span>{{ client.default_email_address }}</span>
            </span>
            <span v-else-if="client.using_email === false" style="border-bottom: 1px dotted gray">
                <span class="text-secondary"><i class="fa fa-envelope-square" aria-hidden="true"></i> Klient nepoužívá email</span>
            </span>
            <span v-else="" style="border-bottom: 1px dotted gray">
                <span class="text-danger"><i class="fa fa-envelope-square" aria-hidden="true"></i> Chybí emailová adresa</span>
            </span>
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_5_col">
                <div class="row tooltip_header">
                    <div class="col-sm-2 text-left"></div>
                    <div class="col-sm-8">E-mailové adresy klienta</div>
                    <div class="col-sm-2 text-right">
                        <button class="btn btn-sm btn-outline-secondary" @click="close"><i class="fa fa-times" aria-hidden="true"></i></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <span>Klient používá email </span>
                        <label class="switch switch-lg switch-text switch-success">
                            <input v-model="clientForUpdate.using_email" type="checkbox" class="switch-input" id="usingEmail" data-testid="client-email-using-toggle" @change="saveUsingMail" :disabled="clientPending">
                            <span class="switch-label" data-on="Ano" data-off="Ne"></span>
                            <span class="switch-handle"></span>
                        </label>
                    </div>
                </div>

                <template v-if="client.using_email">
                <div class="row" v-if="client.email_address.length > 0">
                    <table class="table">
                        <thead>
                        <tr class="row m-0">
                            <th class="col-sm-7">emailová adresa</th>
                            <th class="col-sm-3">výchozí</th>
                            <th class="col-sm-2"> </th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="ea in client.email_address">
                                <tr class="row m-0 text-left" data-testid="client-email-row" :class="ea.default ? 'font-weight-bold' : ''">
                                    <td class="col-sm-7" v-if="editingId !== ea.id">{{ ea.email }}</td>
                                    <td class="col-sm-3" v-if="editingId !== ea.id">{{ ea.default | boolToCS }}</td>
                                    <td class="col-sm-10" v-else="">
                                        <form @submit.prevent="submitFormUpdateEmailAddress">
                                            <div class="input-group">
                                                <input v-model="updatedEmailAddress.email" type="text" placeholder="e-mailová adresa" class="form-control" data-testid="client-email-edit-input" id="emailAddress">
                                                <span class="input-group-addon">
                                                      Výchozí:&nbsp;
                                                    <input v-model="updatedEmailAddress.default" type="checkbox" data-testid="client-email-edit-default">
                                                  </span>
                                                <input v-model="updatedEmailAddress.note" type="text" class="form-control" data-testid="client-email-edit-note" id="emailAddressNote" placeholder="poznámka">
                                                <button v-if="updatedEmailAddressPending === false" data-testid="client-email-edit-save" type="submit" class="btn btn-primary">Uložit</button>
                                                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                            </div>
                                            <small id="emailError" class="form-text text-danger text-left" v-if="updatedEmailAddressError.email">{{ updatedEmailAddressError.email.message }}</small>
                                        </form>
                                    </td>
                                    <td class="text-right col-sm-2">
                                        <button class="btn btn-sm btn-danger" data-testid="client-email-delete" @click="deleteEmailAddress(ea.id)" v-if="editingId === false"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        <button class="btn btn-sm btn-danger disabled" v-else="" disabled="disabled"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        <button class="btn btn-sm btn-secondary" data-testid="client-email-edit-cancel" @click="setEditingEmailAddress(ea)" v-if="editingId === ea.id"><i class="fa fa-times" aria-hidden="true"></i></button>
                                        <button class="btn btn-sm btn-secondary" data-testid="client-email-edit" @click="setEditingEmailAddress(ea)" v-else-if="editingId === false"><i class="fa fa-edit" aria-hidden="true"></i></button>
                                        <button class="btn btn-sm btn-secondary disabled" disabled="disabled" v-else=""><i class="fa fa-edit" aria-hidden="true"></i></button>
                                    </td>
                                </tr>
                                <tr class="row m-0 " v-if="ea.note !== null && ea.note !=='' && editingId !== ea.id">
                                    <td class="col-sm-12 text-left border-top-0 pt-0 font-italic">Poznámka: {{ ea.note }}</td>
                                </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
                <div class="row" v-if="editingId === false">
                    <div class="form-group col-md-12">
                        <form @submit.prevent="submitFormAddEmailAddress">
                        <div class="input-group">
                            <input v-model="newEmailAddress.email" type="text" placeholder="e-mailová adresa" class="form-control" data-testid="client-email-input" id="emailAddress">
                            <span class="input-group-addon">
                          Výchozí:&nbsp;
                        <input v-model="newEmailAddress.default" type="checkbox" data-testid="client-email-default">
                      </span>
                            <input v-model="newEmailAddress.note" type="text" class="form-control" data-testid="client-email-note" id="emailAddressNote" placeholder="poznámka">
                            <button v-if="newEmailAddressPending === false" data-testid="client-email-add" type="submit" class="btn btn-primary">Přidat e-mail</button>
                            <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </div>
                        <small id="emailError" class="form-text text-danger text-left" v-if="newEmailAddressError.email">{{ newEmailAddressError.email.message }}</small>
                        </form>
                    </div>
                </div>
                </template>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        editMode: false,
        isOpen: false,
        newEmailAddress: {
          default: true
        },
        newEmailAddressError: false,
        newEmailAddressPending: false,
        newEmailAddressDone: false,
        updatedEmailAddress: {},
        updatedEmailAddressError: false,
        updatedEmailAddressPending: false,
        updatedEmailAddressDone: false,
        deleteEmailAddressError: false,
        deleteEmailAddressPending: false,
        deleteEmailAddressDone: false,
        editingId: false,
        clientForUpdate: {},
        clientPending: false,
        clientDone: false,
        clientError: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      init () {
        this.newEmailAddress = {
          default: true
        }
        this.newEmailAddressError = false
        this.editingId = false
        this.updatedEmailAddress = {}
        this.updatedEmailAddressError = false
        this.updatedEmailAddressPending = false
        this.updatedEmailAddressDone = false
        this.deleteEmailAddressError = false
        this.deleteEmailAddressPending = false
        this.deleteEmailAddressDone = false
        this.clientForUpdate.using_email = this.client.using_email
        this.clientForUpdate.id = this.client.id
        this.clientPending = false
        this.clientDone = false
        this.clientError = false
      },
      open () {
        this.init()
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      },
      edit () {
        this.editMode = true
      },
      view () {
        this.editMode = false
      },
      submitFormAddEmailAddress () {
        // console.log(this.newEmailAddress)
        this.newEmailAddressError = false
        this.postEmailAddress(this.newEmailAddress, this.client.id)
      },
      submitFormUpdateEmailAddress () {
        // console.log(this.updatedEmailAddress)
        this.updatedEmailAddressError = false
        this.putEmailAddress(this.updatedEmailAddress)
      },
      setEditingEmailAddress (emailAddress) {
        if (this.editingId === false) {
          this.updatedEmailAddress = JSON.parse(JSON.stringify(emailAddress, this.replacer))
          this.editingId = emailAddress.id
        } else {
          this.updatedEmailAddress = {}
          this.editingId = false
        }
      },
      saveUsingMail () {
        this.putClient(this.clientForUpdate)
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          //
        } else {
          //
        }
      },
      newEmailAddressDone (val) {
        if (val === true) {
          this.newEmailAddress = {
            default: true
          }
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.newEmailAddressDone = false
          // this.close()
        }
      },
      deleteEmailAddressDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.deleteEmailAddressDone = false
          // this.close()
        }
      },
      updatedEmailAddressDone (val) {
        if (val === true) {
          this.editingId = false
          this.updatedEmailAddress = {}
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.updatedEmailAddressDone = false
          // this.close()
        }
      },
      clientDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.clientDone = false
          // this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientEmailAddress.vue?fb48f3fc